import { useTranslation } from "react-i18next";
import { ControlledCombobox } from "~/molecules/ControlledCombobox";
import type { UserManagementFiltersModel } from "~/hooks/useUserManagementFilters";
import { FiltersPanel } from "./FiltersPanel";

interface UserManagementFiltersPanelProps {
  filters: UserManagementFiltersModel;
}

export const UserManagementFiltersPanel = ({
  filters,
}: UserManagementFiltersPanelProps) => {
  const { t } = useTranslation();

  return (
    <FiltersPanel>
      <div className="space-y-1">
        <p className="text-sm font-medium">{t(($) => $.commons.user.status)}</p>
        <ControlledCombobox
          isMulti
          value={filters.selectedStatuses}
          options={filters.statusOptions}
          placeholder={
            filters.selectedStatuses.length === 0
              ? t(($) => $.commons.select)
              : t(($) => $.library.filters.selectedCount, {
                  count: filters.selectedStatuses.length,
                })
          }
          onChange={filters.setStatusFilter}
        />
      </div>
    </FiltersPanel>
  );
};
